import { AccessToken } from 'src/apis/auth'
import { ActionTree } from 'vuex'
import { StateInterface } from '../index'
import { AuthStateInterface } from './state'
import types from './types'
import { getProfile, Profile } from 'apis/profile'
import { CustomLogin } from 'src/system/models'

const actions: ActionTree<AuthStateInterface, StateInterface> = {
  async loginComplete({ commit, dispatch }, params: AccessToken) {
    commit(types.LOGIN_COMPLETE, params)
    await dispatch('refreshProfileData')
  },
  updateToken({ commit }, params: AccessToken) {
    commit(types.UPDATE_TOKEN, params)
  },
  async refreshProfileData({ commit }) {
    const profile = await getProfile()
    commit(types.REFRESH_PROFILE, profile)
  },
  setCustomLogin({ commit }, params: CustomLogin) {
    commit(types.SET_CUSTOM_LOGIN, params)
  },
  clearCustomLogin({ commit }) {
    commit(types.CLEAR_CUSTOM_LOGIN)
  },
  updateProfileData({ commit }, params: Profile) {
    commit(types.REFRESH_PROFILE, params)
  },
  logout({ commit }) {
    commit(types.LOGOUT_COMPLETE)
  },
}

export default actions
